import React, { Component } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { Title, GET_LIST } from 'react-admin'

import Grid from '@material-ui/core/Grid'

import { TotalInstalacionWidget } from '../Dashboard'

import Notification from './Notification'

import Typography from '@material-ui/core/Typography'
import dataProvider from '../../utils/dataProvider'


 class Dashboard extends Component {

    state = {
        totales : []
    } 

    componentDidMount () {
        const params = {
            pagination: { page: 1, perPage: 10 },
            sort: {},
        }
        dataProvider(GET_LIST, "estadisticas-instalaciones", params)
            .then(response => {
                console.log(response.data)
                this.setState({
                    totales : response.data
                })
            })
    }
 
 
    render () {

        const { totales } = this.state
        
        return (
            <Card>
                <Title title="Bienvenido a Base de Datos Contable" />
                <CardContent>

                    <Typography variant={'title'}>
                        Bienvenido a Activos de Transmisión
                    </Typography>
                    <br/>
                    <br/>

                    <Grid container spacing={16}>
                        {totales.map(t => (
                        <Grid key={t.type} item xs={12} md={6} lg={3}>
                            <TotalInstalacionWidget data={{
                                name : t.name, 
                                total : t.count, 
                                path : t.type
                            }} />
                        </Grid>
                        ))}
                    </Grid>
                    <br/>
                    <br/>
                    <br/>
                    <Grid container spacing={16}>
                        <Grid item xs={12} md={6}>
                        <Notification/>
                        </Grid>
                    </Grid>


                </CardContent>
            </Card>
        )
    }

}


export default Dashboard